// extracted by mini-css-extract-plugin
export default {"card":"N6-z"};